import { FC } from "react";

import { I18nKeyType } from "@/i18n";
import { useTranslate } from "@/i18n/useTranslate";

import {
  DriverFlowBottomButton,
  DriverFlowBottomButtonPropsType,
} from "../blocks";
import { DsLoading, DsText } from "../components/ui";
import { JobServiceTaskBaseType } from "../domain/task";
import { DriverTopActionButton } from "./DriverTopActionButton";

export type DriverStepScreenWrapperPropsType = DriverFlowBottomButtonPropsType &
  JobServiceTaskBaseType & {
    title: I18nKeyType;
    titlei18nOptions?: object;
    children?: React.ReactNode;
    shouldShowTopActionButton?: boolean;
    isLoading?: boolean;
  };

const DriverStepScreenWrapper: FC<DriverStepScreenWrapperPropsType> = ({
  title,
  titlei18nOptions,
  jobId,
  serviceId,
  taskId,
  children,
  shouldShowTopActionButton = true,
  isLoading,
  ...bottomButtonsProps
}) => {
  const parsedTitle = useTranslate(title, titlei18nOptions);
  const loadingText = useTranslate("driver_step_screen_wrapper.loading");

  return (
    <div className="flex flex-col h-full w-full">
      {shouldShowTopActionButton && (
        <DriverTopActionButton
          jobId={jobId}
          serviceId={serviceId}
          taskId={taskId}
        />
      )}
      <div className="flex flex-grow w-full flex-col justify-center">
        {isLoading ? (
          <div className="flex flex-col justify-center items-center gap-4">
            <DsText variant="pageTitle">{loadingText}</DsText>
            <DsLoading />
          </div>
        ) : (
          <div>
            <DsText className="mb-2" variant="pageTitle">
              {parsedTitle}
            </DsText>
            {children}
          </div>
        )}
      </div>
      <DriverFlowBottomButton {...bottomButtonsProps} />
    </div>
  );
};

export { DriverStepScreenWrapper };
